import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Info from './steps/Info';
import PreEx from './steps/PreEx';
import Description from './steps/Description';
import OtherParties from './steps/OtherParties';
import PersonalInformation from './steps/PersonalInformation';
import Reimbursement from './steps/Reimbursement';
import IDVerification from './steps/IDVerification';
import UploadDocuments from './steps/UploadDocuments';
import Summary from './steps/Summary';
import ChooseClaimType from './ChooseClaimType';
import Confirmation from './components/Confirmation';
import { CLAIM_TYPES, STEP_PATHS } from './consts';

export const STEP_MAP = {
  [STEP_PATHS.TRAVEL_INFORMATION]: Info,
  [STEP_PATHS.PRE_EX]: PreEx,
  [STEP_PATHS.DESCRIPTION]: Description,
  [STEP_PATHS.OTHER_PARTIES]: OtherParties,
  [STEP_PATHS.PERSONAL_INFORMATION]: PersonalInformation,
  [STEP_PATHS.REIMBURSEMENT]: Reimbursement,
  [STEP_PATHS.UPLOAD_DOCUMENTS]: UploadDocuments,
  [STEP_PATHS.ID_VERIFICATION]: IDVerification,
  [STEP_PATHS.SUMMARY]: Summary
};

const Routes = () => {
  return (
    <Switch>
      <Route exact path="/nomad-insurance/claim" component={ChooseClaimType} />

      {Object.entries(STEP_MAP).map(([path, component]) => (
        <Route
          exact
          key={path}
          path={`/nomad-insurance/claim/:claimType(${Object.values(CLAIM_TYPES).join(
            '|'
          )})/:step(${path})`}
          component={component}
        />
      ))}
      <Route
        exact
        path="/nomad-insurance/claim/:claimType/confirmation"
        component={Confirmation}
      />

      {/* Redirect if claimType does not match medical or non-medical */}
      <Route path="/nomad-insurance/claim/:claimType">
        <Redirect to="/nomad-insurance/claim" />
      </Route>
    </Switch>
  );
};

export default Routes;
